import React from 'react';

// An illustrative condition, not a model-specific repair guide or diagnostic result.
export function ChromebookCaseVisual({ condition }: { condition: string }) {
  if (!['blank', 'damaged', 'readable'].includes(condition)) return null;
  const description = condition === 'blank' ? 'The display is blank; the cause is unknown.'
    : condition === 'damaged' ? 'Visible cracks obscure part of the display.'
      : 'The simulated assignment text is readable.';
  return <figure className="my-4 rounded-xl border border-purple-200 bg-purple-50 p-4">
    <figcaption className="mb-3 text-sm font-semibold text-purple-900">Simulated Chromebook — {description}</figcaption>
    <svg viewBox="0 0 480 270" role="img" aria-label={description} className="mx-auto w-full max-w-lg">
      <rect x="55" y="12" width="370" height="220" rx="12" fill="#334155" />
      <rect x="70" y="27" width="340" height="187" rx="3" fill={condition === 'blank' ? '#0f172a' : '#fff'} />
      {condition !== 'blank' && <g fill="#334155"><text x="90" y="65" fontSize="17">Classroom assignment</text><text x="90" y="100" fontSize="14">Read the directions.</text><text x="90" y="128" fontSize="14">Identify the user's task.</text></g>}
      {condition === 'damaged' && <g stroke="#6b21a8" strokeWidth="5" fill="none"><path d="M275 28 L220 93 L288 140 L235 214 M220 93 L110 170 M288 140 L400 65" /></g>}
      <path d="M55 232 L12 256 Q240 275 468 256 L425 232 Z" fill="#64748b" />
    </svg>
    <p className="mt-2 text-sm text-slate-600">Training illustration only. It does not identify a failed part or show a physical repair.</p>
  </figure>;
}
